// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"VO-z","categoryName":"WO-z","categoryNameSearchHeader":"XO-z","categoryContent":"YO-z","bottomAligned":"ZO-z","image":"_O-z","imageNoBackground":"aP-z"};